import MissingList from "../missingList";
import * as s from "./SubHeaderStyled";
import WIDGET_CLOSE from "assets/icons/widget_close.svg";
import WIDGET_CLOSE_LIGHT from "assets/icons/widget_close_light.svg";
import WIDGET_OPEN from "assets/icons/widget_open.svg";
import { useCallback, useEffect, useMemo, useRef, useState } from "react";
import AccountFilter from "./filters/account/AccountFilter";
import RecorderFilter from "./filters/recorder/RecorderFilter";
import AlertFilter from "./filters/alert/AlertFilter";
import { AnimatePresence } from "framer-motion";
import { useAppDispatch, useAppSelector } from "redux/hooks";
import * as mediaQuery from "components/MediaQuery";
import { BsCaretDownFill } from "react-icons/bs";
import MapSearchInput from "components/atoms/input/search/MapSearchInput";
import { useQuery } from "react-query";
import { getKeywordList } from "api/dashboardAPI";
import { ProfileAccountInfo } from "api/interfaces/accountInterface.interface";
import {
  BasePagination,
  SORT_DIRECTION,
} from "api/interfaces/commonInterface.interface";
import {
  MapFilterKeyword,
  mapFilterInitialState,
  setInitialState,
  setKeyword,
  setStatus,
} from "redux/reducers/map/mapFilter";
import { Popover } from "antd";
import StatusFilter from "./filters/status/StatusFilter";
import MoreFilter from "./filters/more/MoreFilter";
import { IoMdClose } from "react-icons/io";
import TypeFilter, { typeList } from "./filters/type/TypeFilter";
import {
  DashboardFilter,
  KeywordSearch,
  KeywordSearchRecorder,
} from "api/interfaces/dashboardInterface.interface";
import { changeFirstWordToUppercase } from "utils/functions";
import { BsThreeDotsVertical } from "react-icons/bs";
import { TbChevronsDown, TbChevronsUp } from "react-icons/tb";
import CHEVRON_LEFT from "assets/icons/chevron_left_slide.svg";
import CHEVRON_RIGHT from "assets/icons/chevron_right_slide.svg";
import { useAlertRules } from "hook/useAlertRules";
import { setSearchAsMoved } from "redux/stomp/stompMapSlice";

type Props = {
  isCollapsed: boolean;
  onChangeCollapsed: () => void;
  onSearch: (e: MapFilterKeyword) => void;
  onResetSearchInput: () => void;
  more: More;
  onSelectMoreFilter: (e: any) => void;
  onDeleteMoreFilter: (name: string) => void;
  onClickRecorder: (id: string) => void;
  onClickRecorderKeyword: (rec: KeywordSearchRecorder) => void;
};

export type More = {
  [status: string]: boolean;
};

interface Open {
  [key: string]: boolean;
}

interface FilterLabel {
  [key: string]: string;
}
const SubHeader = (props: Props): JSX.Element => {
  const dispatch = useAppDispatch();

  const selectedAccount: ProfileAccountInfo = useAppSelector(
    (state) => state.accountSettings
  );
  const mapFilter: DashboardFilter = useAppSelector(
    (state) => state.mapFilter.filters
  );
  const mapFilterKeyword: MapFilterKeyword = useAppSelector(
    (state) => state.mapFilter.keyword
  );
  const theme = useAppSelector((state) => state.theme.theme);
  const searchAsMoved = useAppSelector((state) => state.mapStomp.searchAsMoved);
  const isMobile = mediaQuery.useIsMobile();
  const { hasAlertRuleList } = useAlertRules({});

  const [keywordListListQueryInfo, setKeywordListQueryInfo] =
    useState<BasePagination>({
      total: 0,
      pageNum: 0,
      pageLimit: 10,
      keyword: "",
      sortType: "",
      sortDirection: SORT_DIRECTION.ASC,
    });

  const [isSelectOpen, setIsSelectOpen] = useState<Open>({
    status: false,
    accounts: false,
    alerts: false,
    types: false,
    recorders: false,
    recorderGroup: false,
    more: false,
  });

  const [isAssignedAlert, setIsAssignedAlert] = useState<boolean>(false);

  const [isFiltering, setIsFiltering] = useState<Open>({
    status: false,
    accounts: false,
    alerts: false,
    types: false,
    recorders: false,
    recorderGroup: false,
    more: false,
  });

  const [searchKeywordList, setSearchKeywordList] = useState<KeywordSearch[]>(
    []
  );

  const [filterLabels, setFilterLabels] = useState<FilterLabel>({
    status: hasAlertRuleList ? "No Alert Rule" : "Status",
    accounts: "Organization",
    alerts: "Alert",
    types: "Type",
    recorders: "Recorder",
    recorderGroup: "Recorder Group",
    more: "More",
  });

  const onClickSearch = (keyword: string) => {
    props.onSearch({ type: "", keyword });
  };

  const onClickKeyword = (content: KeywordSearch) => {
    onClickSearch(content.searchedString);

    if (content.recorder) {
      props.onClickRecorder(content.recorder.recorderId);
      props.onClickRecorderKeyword(content.recorder);
    }
  };

  const onSelectMoreFilter = (e: any) => {
    let {
      target: { name },
    } = e;

    props.onSelectMoreFilter(e);

    setIsSelectOpen({
      ...isSelectOpen,
      more: false,
      [name]: true,
    });
  };

  const onChangeSearchMove = (checked: boolean) => {
    dispatch(setSearchAsMoved(checked));
  };

  const onChangeSelectOpen = (name: string) => {
    const tempNewState = { ...isSelectOpen };
    Object.keys(tempNewState).forEach((key) => {
      if (key !== name) {
        tempNewState[key] = false;
      } else {
        tempNewState[key] = !tempNewState[key];
      }
    });
    setIsSelectOpen(tempNewState);
  };

  const onApply = (type: string) => {
    onChangeSelectOpen(type);
  };
  const onChangeFiltering = useCallback(
    (name: string, value: boolean) => {
      // console.log(isFiltering);
      setIsFiltering((state: Open) => {
        return {
          ...state,
          [name]: value,
        };
      });
    },
    [setIsFiltering]
  );

  const onChangeFilterName = (label: string, changeFilterName: string) => {
    // console.log("onChangeFilterName", filterLabels, label, changeFilterName);
    setFilterLabels((state: FilterLabel) => {
      return {
        ...state,
        [label]: changeFilterName,
      };
    });
  };

  const horizontalScrollRef = useRef<any>(null);

  const handleNextButtonClick = (nextType: "prev" | "next") => {
    if (!horizontalScrollRef.current) return;
    if (nextType === "prev") {
      horizontalScrollRef.current.scrollTo({
        left:
          horizontalScrollRef.current.scrollLeft -
          horizontalScrollRef.current.offsetWidth,
        behavior: "smooth",
      });
    } else {
      horizontalScrollRef.current.scrollTo({
        left:
          horizontalScrollRef.current.scrollLeft +
          horizontalScrollRef.current.offsetWidth,
        behavior: "smooth",
      });
    }
  };

  const [isOverflow, setIsOverflow] = useState<{ [key: string]: boolean }>({
    left: false,
    right: false,
  });

  const checkOverflow = () => {
    if (!horizontalScrollRef.current) return;
    const { scrollLeft, scrollWidth, clientWidth } =
      horizontalScrollRef.current;

    setIsOverflow({
      left: scrollLeft > 0,
      right: scrollLeft + clientWidth < scrollWidth,
    });
  };

  useEffect(() => {
    if (!horizontalScrollRef.current) return;

    const ref = horizontalScrollRef.current;
    checkOverflow(); // Initial check

    ref.addEventListener("scroll", checkOverflow);
    window.addEventListener("resize", checkOverflow);

    return () => {
      ref.removeEventListener("scroll", checkOverflow);
      window.removeEventListener("resize", checkOverflow);
    };
  }, [horizontalScrollRef, isSelectOpen]);

  const moreMenu = {
    label: "More",
    name: "more",
    open: isSelectOpen.more,
    filter: <MoreFilter more={props.more} onChange={onSelectMoreFilter} />,
  };
  const selectMenus = useMemo(() => {
    return [
      {
        label: "Status",
        name: "status",
        open: isSelectOpen.status,
        filter: (
          <StatusFilter
            onApply={() => onApply("status")}
            onChangeFiltering={onChangeFiltering}
          />
        ),
      },
      {
        label: "Organization",
        name: "accounts",
        open: isSelectOpen.accounts,
        filter: (
          <AccountFilter
            isOpen={isSelectOpen.accounts}
            onApplyAccount={() => onApply("accounts")}
            onChangeFiltering={onChangeFiltering}
            onChangeFilterName={(filterName: string) =>
              onChangeFilterName("accounts", filterName)
            }
          />
        ),
      },
      {
        label: "Recorder",
        name: "recorders",
        open: isSelectOpen.recorders,
        filter: (
          <RecorderFilter
            isOpen={isSelectOpen.recorders}
            type="recorder"
            onApply={() => onApply("recorders")}
            onChangeFiltering={onChangeFiltering}
            onChangeFilterName={(filterName: string) =>
              onChangeFilterName("recorders", filterName)
            }
          />
        ),
      },
    ];
  }, [isSelectOpen]);

  const moreMenus = useMemo(() => {
    return [
      {
        label: "Recorder Type",
        name: "types",
        open: isSelectOpen.type,
        filter: (
          <TypeFilter
            onApply={() => onApply("types")}
            onChangeFiltering={onChangeFiltering}
          />
        ),
      },
      {
        label: "Recorder",
        name: "recorders",
        open: isSelectOpen.recorders,
        filter: (
          <RecorderFilter
            isOpen={isSelectOpen.recorders}
            type="recorder"
            onApply={() => onApply("recorders")}
            onChangeFiltering={onChangeFiltering}
            onChangeFilterName={(filterName: string) =>
              onChangeFilterName("recorders", filterName)
            }
          />
        ),
      },
      {
        label: "Alert",
        name: "alerts",
        open: isSelectOpen.alert,
        filter: (
          <AlertFilter
            onApply={() => onApply("alerts")}
            onChangeFiltering={onChangeFiltering}
            onChangeFilterName={(filterName: string) =>
              onChangeFilterName("alerts", filterName)
            }
          />
        ),
      },
      {
        label: "Recorder Group",
        name: "recorderGroup",
        open: isSelectOpen.recorderGroup,
        filter: (
          <RecorderFilter
            isOpen={isSelectOpen.recorderGroup}
            type="group"
            onApply={() => onApply("recorderGroup")}
            onChangeFiltering={onChangeFiltering}
            onChangeFilterName={(filterName: string) =>
              onChangeFilterName("recorderGroup", filterName)
            }
          />
        ),
      },
    ].filter((menu) => {
      if (menu.name === "alerts") {
        return selectedAccount.userPermission.viewAlerts;
      }
      return true;
    });
  }, [isSelectOpen, selectedAccount.userPermission.viewAlerts]);

  const onPowerSearch = (value: string) => {
    setKeywordListQueryInfo({
      ...keywordListListQueryInfo,
      keyword: value,
    });
  };

  const searchKeywordListQuery = useQuery(
    ["keywordList", keywordListListQueryInfo.keyword],
    () =>
      getKeywordList({
        accountId: selectedAccount.accountId,
        payload: keywordListListQueryInfo,
      }),
    {
      retry: 0,
      enabled:
        keywordListListQueryInfo.keyword !== undefined &&
        keywordListListQueryInfo.keyword !== "" &&
        keywordListListQueryInfo.keyword.length > 0,
      refetchOnMount: false,
      refetchOnWindowFocus: false,
      onSuccess: (res: any) => {
        // console.log(res, "search keyword 2 2222222");
        if (res.result) {
          // dispatch(setDashboardSearchData(res.result));
          setSearchKeywordList(res.result);
        } else {
          // dispatch(setDashboardSearchData([]));
          setSearchKeywordList([]);
        }
      },
      // onSettled: () => {},
    }
  );

  useEffect(() => {
    if (
      keywordListListQueryInfo.keyword !== undefined &&
      (keywordListListQueryInfo.keyword === "" ||
        keywordListListQueryInfo.keyword.length > 0)
    ) {
      setSearchKeywordList([]);
    }
  }, [keywordListListQueryInfo.keyword]);

  useEffect(() => {
    // console.log(mapFilter.keyword, "subheader keyword");
    setKeywordListQueryInfo({
      ...keywordListListQueryInfo,
      keyword: mapFilterKeyword.keyword,
    });
  }, [mapFilterKeyword]);

  useEffect(() => {
    let tempFilterName = "Status";
    let tempStatusArr: [string, boolean][] = [
      ["healthy", mapFilter.status.healthy],
      ["warning", mapFilter.status.warning],
      ["alert", mapFilter.status.alert],
      ["critical", mapFilter.status.critical],
    ];

    if (isFiltering.status) {
      // 모두 filtering 일 때
      if (
        tempStatusArr.filter((stat) => stat[1]).length === tempStatusArr.length
      ) {
        tempFilterName = "All Status";
      }
      // 1,2개만 filtering 일 때
      else {
        tempFilterName = tempStatusArr
          .filter((stat) => stat[1])
          .map((st) => changeFirstWordToUppercase(st[0]))
          .join();
      }
    }
    onChangeFilterName("status", tempFilterName);
  }, [isFiltering.status, mapFilter.status]);

  useEffect(() => {
    let tempFilterName = "Recorder Types";
    let tempTypeArr = Object.entries(mapFilter.types);
    if (isFiltering.types) {
      // 모두 filtering 일 때
      if (tempTypeArr.filter((stat) => stat[1]).length === tempTypeArr.length) {
        tempFilterName = "All Types";
      }
      // 1,2개만 filtering 일 때
      else {
        tempFilterName = tempTypeArr
          .filter((stat) => stat[1])
          .map((st) => {
            return typeList.find((type) => type.value === st[0])?.label;
          })
          .join();
      }
    }
    onChangeFilterName("types", tempFilterName);
  }, [isFiltering.types, mapFilter.types]);

  useEffect(() => {
    dispatch(setKeyword(mapFilterInitialState.keyword));
  }, [selectedAccount]);

  useEffect(() => {
    dispatch(
      setStatus({
        ...mapFilter.status,
        assigned: isAssignedAlert,
      })
    );
  }, [isAssignedAlert]);

  return (
    <s.Container className="subheader-container">
      <s.Inner>
        {selectedAccount.isEnabled ? (
          <s.Left>
            <mediaQuery.Mobile>
              {isOverflow.left && (
                <s.ScrollButton
                  className="button-left"
                  onClick={() => handleNextButtonClick("prev")}
                  data-testid="dashboard-map-subheader-scroll-button-next-button"
                >
                  <img src={CHEVRON_LEFT} alt="left" />
                </s.ScrollButton>
              )}

              {isOverflow.right && (
                <s.ScrollButton
                  className="button-right"
                  onClick={() => handleNextButtonClick("next")}
                  data-testid="dashboard-map-subheader-scroll-button-next-button-2"
                >
                  <img src={CHEVRON_RIGHT} alt="right" />
                </s.ScrollButton>
              )}
            </mediaQuery.Mobile>

            <AnimatePresence>
              <s.FilterLeft
                initial={{
                  rotateX: 0,
                  // scaleY: -1,
                }}
                animate={{
                  rotateX: 180,
                  scaleY: -1,
                  // transition: { duration: 1 },
                }}
                exit={{
                  rotateX: 0,
                  // scaleY: -1
                }}
              >
                <MapSearchInput
                  keyword={keywordListListQueryInfo.keyword}
                  placeholder="Search In Result"
                  onPowerSearch={onPowerSearch}
                  onClickKeyword={onClickKeyword}
                  onClickSearch={onClickSearch}
                  searchKeywordList={searchKeywordList}
                />

                <s.FilterLeftInner ref={horizontalScrollRef}>
                  {selectMenus.map((menu, index) => {
                    // console.log(filterLabels, " filterlabels");
                    if (
                      (selectedAccount.accountLevel === "EU" &&
                        menu.name !== "accounts") ||
                      ((selectedAccount.accountLevel === "CP" ||
                        selectedAccount.accountLevel === "DW") &&
                        menu.name !== "recorders")
                    ) {
                      return (
                        <Popover
                          key={menu.label}
                          content={menu.filter}
                          placement={isMobile ? "bottom" : "bottomLeft"}
                          trigger={"click"}
                          arrow={false}
                          open={isSelectOpen[menu.name]}
                          getPopupContainer={
                            document.querySelector(".subheader-container")
                              ? () =>
                                  document.querySelector(
                                    ".subheader-container"
                                  ) as HTMLElement
                              : undefined
                          }
                          onOpenChange={(open: boolean) => {
                            setIsSelectOpen({
                              ...isSelectOpen,
                              [menu.name]: open,
                            });
                          }}
                        >
                          <s.SelectFilter
                            key={index}
                            isOpen={isSelectOpen[menu.name]}
                            onClick={() => onChangeSelectOpen(menu.name)}
                            isFilter={isFiltering[menu.name]}
                            data-testid="dashboard-map-subheader-select-filter-change-select-open"
                          >
                            <span>{filterLabels[menu.name]}</span>
                            <BsCaretDownFill size={12} />
                          </s.SelectFilter>
                        </Popover>
                      );
                    }
                    return null;
                  })}
                  {moreMenus.map((m, index) => {
                    if (props.more[m.name]) {
                      return (
                        <Popover
                          key={m.name}
                          content={m.filter}
                          placement="bottomLeft"
                          trigger={"click"}
                          arrow={false}
                          open={isSelectOpen[m.name]}
                          getPopupContainer={
                            document.querySelector(".subheader-container")
                              ? () =>
                                  document.querySelector(
                                    ".subheader-container"
                                  ) as HTMLElement
                              : undefined
                          }
                          onOpenChange={(open: boolean) => {
                            setIsSelectOpen({
                              ...isSelectOpen,
                              [m.name]: open,
                            });
                          }}
                        >
                          <s.SelectFilter
                            key={`more-${index}`}
                            onClick={() => onChangeSelectOpen(m.name)}
                            isOpen={isSelectOpen[m.name]}
                            isFilter={isFiltering[m.name]}
                            data-testid="dashboard-map-subheader-select-filter-change-select-open-2"
                          >
                            <span>{filterLabels[m.name]}</span>

                            <button
                              onClick={() => props.onDeleteMoreFilter(m.name)}
                              data-testid="dashboard-map-subheader-button-delete-more-filter"
                            >
                              <IoMdClose size={12} />
                            </button>
                          </s.SelectFilter>
                        </Popover>
                      );
                    }
                    return null;
                  })}

                  <Popover
                    content={moreMenu.filter}
                    placement="bottomLeft"
                    trigger={"click"}
                    arrow={false}
                    open={isSelectOpen[moreMenu.name]}
                    onOpenChange={(open: boolean) => {
                      setIsSelectOpen({
                        ...isSelectOpen,
                        [moreMenu.name]: open,
                      });
                    }}
                    getPopupContainer={
                      document.querySelector(".subheader-container")
                        ? () =>
                            document.querySelector(
                              ".subheader-container"
                            ) as HTMLElement
                        : undefined
                    }
                  >
                    <s.SelectFilter
                      isOpen={isSelectOpen[moreMenu.name]}
                      onClick={() => onChangeSelectOpen(moreMenu.name)}
                      isFilter={isFiltering[moreMenu.name]}
                      data-testid="dashboard-map-subheader-select-filter-change-select-open-3"
                    >
                      {filterLabels[moreMenu.name]}
                      <BsCaretDownFill size={12} />
                    </s.SelectFilter>
                  </Popover>
                </s.FilterLeftInner>
              </s.FilterLeft>
            </AnimatePresence>
          </s.Left>
        ) : (
          <s.Left></s.Left>
        )}

        <mediaQuery.Default>
          <s.Right>
            {selectedAccount.isEnabled && (
              <Popover
                content={
                  <div>
                    <s.SearchInMap>
                      <input
                        type="checkbox"
                        checked={searchAsMoved}
                        onChange={(e) =>
                          onChangeSearchMove(e.currentTarget.checked)
                        }
                        data-testid="dashboard-map-subheader-input-change-search-move"
                      />
                      Only Recorders In View
                      {/* Show only recorders on map */}
                    </s.SearchInMap>

                    <s.SearchInMap>
                      <input
                        type="checkbox"
                        checked={isAssignedAlert}
                        onChange={(e) =>
                          setIsAssignedAlert(e.currentTarget.checked)
                        }
                        data-testid="dashboard-map-subheader-input-set-is-assigned-alert"
                      />
                      Only Assigned Alert
                    </s.SearchInMap>
                  </div>
                }
                placement="bottomRight"
                trigger={"click"}
              >
                <s.MapCircleButton>
                  <BsThreeDotsVertical />
                </s.MapCircleButton>
              </Popover>
            )}

            <MissingList />
            <s.CollapseButton
              isCollapsed={props.isCollapsed}
              onClick={props.onChangeCollapsed}
              data-testid="dashboard-map-subheader-collapse-button-change-collapsed"
            >
              <mediaQuery.Mobile>
                {props.isCollapsed ? (
                  <TbChevronsDown size={20} />
                ) : (
                  <TbChevronsUp size={20} />
                )}
              </mediaQuery.Mobile>
              <mediaQuery.Default>
                <img
                  src={
                    props.isCollapsed
                      ? WIDGET_OPEN
                      : theme === "light"
                      ? WIDGET_CLOSE_LIGHT
                      : WIDGET_CLOSE
                  }
                  alt="widget icon"
                />
              </mediaQuery.Default>
            </s.CollapseButton>
          </s.Right>
        </mediaQuery.Default>
      </s.Inner>
    </s.Container>
  );
};

export default SubHeader;
